import React from 'react';

import { defaultFormatters, defaultOperators, defaultRenderers } from 'components/Grid';
import { ColumnActions, ColumnDefinition } from 'components/Grid/types';
import { ActiveStatusOperator } from 'components/Grid/operators/ActiveStatus';
import Chip from 'components/Chip';

import { FULL_DATETIME_COLUMN_MIN_WIDTH, FULL_DATETIME_FORMAT, ProtectorType } from 'core/constants';

import { formatMoment } from 'utils/formatters/timezone';

import { colors } from 'theme/colors';

import RiskAssessmentTemplateActionCell, { RiskAssessmentTemplateRow } from './RiskAssessmentTemplateActionCell';

const STATUS_LABELS = { active: 'Published', inactive: 'Archived' };

export const riskAssessmentTemplatesColumns = [
  {
    field: 'name',
    headerName: 'Template name',
    flex: 1,
    minWidth: 240,
    nativeFilter: 'name',
    protectorType: ProtectorType.ShortText,
  },
  {
    field: 'status',
    headerName: 'Status',
    width: 160,
    nativeFilter: 'active',
    filterOperators: ActiveStatusOperator(STATUS_LABELS, { allowIsNot: true }),
    renderCell: ({ row }: { row: RiskAssessmentTemplateRow }) => (
      <Chip
        label={row.isActive ? STATUS_LABELS.active : STATUS_LABELS.inactive}
        size="small"
        capitalizeLabel={false}
        colors={{
          background: row.isActive ? colors.ui.status.completed : colors.grey[200],
          foreground: colors.common.black,
        }}
      />
    ),
  },
  {
    field: 'updatedAt',
    headerName: 'Last published',
    minWidth: FULL_DATETIME_COLUMN_MIN_WIDTH,
    nativeFilter: 'updatedAt',
    protectorType: ProtectorType.DateTime,
    filterOperators: defaultOperators.date_time(),
    valueFormatter: (value: string | null) => formatMoment(value, FULL_DATETIME_FORMAT),
    renderCell: ({ value }: { value: string }) => (
      <span data-testid="risk-templates-last-published">{formatMoment(value, FULL_DATETIME_FORMAT)}</span>
    ),
  },
  {
    field: 'creator',
    headerName: 'Creator',
    defaultVisibility: false,
    sortable: false,
    nativeFilter: 'creator',
    renderCell: defaultRenderers.user,
    valueGetter: (value: unknown) => ({ value }),
    valueFormatter: defaultFormatters.user,
    filterOperators: defaultOperators.user(),
  },
  {
    field: 'actions',
    type: 'actions',
    headerName: '',
    maxWidth: 50,
    ariaLabel: 'actions_cell',
    sortable: false,
    filterOperators: null,
    renderCell: ({ row, colDef }: { row: RiskAssessmentTemplateRow; colDef: { actions: ColumnActions } }) => (
      <RiskAssessmentTemplateActionCell row={row} actions={colDef.actions} />
    ),
  },
] as unknown as ColumnDefinition[];
